import { EVerticalNames } from '@constants';
import { useMemo } from 'react';

import { WidgetWrapper } from '../shared/WidgetShared.styles';

import { ProgressFp } from './components/ProgressFp';
import { ProgressWithoutPlanification } from './components/ProgressWithoutPlanification';
import { ProgressWithPlanification } from './components/ProgressWithPlanification';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { useMyPlanification, useProfile } from '@/store';

export const ProgressWidget: React.FC = () => {
  const { planification, isLoading } = useMyPlanification();
  const { profile, isLoading: isProfileLoading } = useProfile();

  const isFp = useMemo(
    () => profile?.tags.some(tag => tag.vertical === EVerticalNames.FP),
    [profile]
  );

  if (isLoading || isProfileLoading) {
    return (
      <WidgetWrapper>
        <LoadingCircleSpinner />
      </WidgetWrapper>
    );
  }

  if (isFp) {
    return <ProgressFp />;
  }

  if (!planification) {
    return <ProgressWithoutPlanification />;
  }

  return <ProgressWithPlanification />;
};
